import React, {PropsWithChildren, useContext} from 'react';
import {gql} from '@apollo/client';
import {GlobalPermissionEnum} from '../schema-types/globalTypes';
import {
  GetLoginInfo_getCurrentUser,
  GetLoginInfo_getCurrentUser_businessUnit,
} from '../schema-types/GetLoginInfo';
import {getEnvironment} from '../utils/envTest';
import {NotificationFragment} from '../schema-types/NotificationFragment';

export type AuthContextType = {
  loading: boolean;
  setLoading: (x: boolean) => void;
};

export const AuthDefault: AuthContextType = {
  loading: true,
  setLoading(x) {},
};

export const getBusinessUnitsQuery = gql`
  query GetBusinessUnits {
    businessUnits {
      id
      name
      divisionName
      partnershipType
    }
  }
`;

export type DjangoContextType = {
  djangoUser: GetLoginInfo_getCurrentUser;
  businessUnit: GetLoginInfo_getCurrentUser_businessUnit; // undefined means loading
  perms: GlobalPermissionEnum[];
  notifications: NotificationFragment[];
};

export const DjangoContext = React.createContext<DjangoContextType>({
  djangoUser: null as any,
  businessUnit: null as any,
  perms: [],
  notifications: [],
  // loading: true,
});

export const useDjangoContext = () => {
  const context = useContext(DjangoContext);
  return context;
};

type roles = 'user' | 'dev' | 'tester';

export const isDevOrTester = (djangoUser: GetLoginInfo_getCurrentUser | null) =>
  djangoUser?.isUserDev || djangoUser?.isUserTester;

export const ShowIfRole: React.FC<PropsWithChildren<{roles: roles[]}>> = ({
  roles,
  children,
}) => {
  const {djangoUser} = useDjangoContext();

  if (getEnvironment() === 'PROD') {
    if (roles.includes('dev') && djangoUser.isUserDev) {
      return <>{children}</>;
    }

    if (roles.includes('tester') && djangoUser.isUserTester) {
      return <>{children}</>;
    }

    return null;
  }

  return <>{children}</>;
};
